import {
  AppConfigurations,
  ExtraBasicInfoQuestions,
} from '@/types/app-configurations';
import { Tenant } from '@/types/common';
import { User } from '@/types/user';

import {
  anguillaConfigs,
  getExtraBasicInfoQuestions as anguillaGetExtraBasicInfoQuestions,
} from './anguilla';
import {
  barbadosConfigs,
  getExtraBasicInfoQuestions as barbadosGetExtraBasicInfoQuestions,
} from './barbados';
import {
  bviConfigs,
  getExtraBasicInfoQuestions as bviGetExtraBasicInfoQuestions,
} from './bvi';
import {
  caymanConfigs,
  getExtraBasicInfoQuestions as caymanGetExtraBasicInfoQuestions,
} from './cayman';
import { defaultConfigs } from './default';
import {
  dominicaConfigs,
  getExtraBasicInfoQuestions as dominicaGetExtraBasicInfoQuestions,
} from './dominica';
import {
  grenadaConfigs,
  getExtraBasicInfoQuestions as grenadaGetExtraBasicInfoQuestions,
} from './grenada';
import {
  guyanaConfigs,
  getExtraBasicInfoQuestions as guyanaGetExtraBasicInfoQuestions,
} from './guyana';
import {
  saintKittsNevisConfigs,
  getExtraBasicInfoQuestions as saintKittsNevisGetExtraBasicInfoQuestions,
} from './saintKittsNevis';
import {
  saintLuciaConfigs,
  getExtraBasicInfoQuestions as saintLuciaGetExtraBasicInfoQuestions,
} from './saintLucia';
import {
  saintVincentConfigs,
  getExtraBasicInfoQuestions as saintVincentGetExtraBasicInfoQuestions,
} from './saintVincent';
import {
  sintMaartenConfigs,
  getExtraBasicInfoQuestions as sintMaartenGetExtraBasicInfoQuestions,
} from './sintMaarten';
import {
  surinameConfigs,
  getExtraBasicInfoQuestions as surinameGetExtraBasicInfoQuestions,
} from './suriname';
import {
  trinidadConfigs,
  getExtraBasicInfoQuestions as trinidadGetExtraBasicInfoQuestions,
} from './trinidad';

export const appConfigs: Record<Tenant, AppConfigurations> = {
  [Tenant.BVI]: bviConfigs,
  [Tenant.Barbados]: barbadosConfigs,
  [Tenant.Grenada]: grenadaConfigs,
  [Tenant.Anguilla]: anguillaConfigs,
  [Tenant.Dominica]: dominicaConfigs,
  [Tenant.SaintKittsNevis]: saintKittsNevisConfigs,
  [Tenant.SaintLucia]: saintLuciaConfigs,
  [Tenant.SaintVincent]: saintVincentConfigs,
  [Tenant.SintMaarten]: sintMaartenConfigs,
  [Tenant.Guyana]: guyanaConfigs,
  [Tenant.Suriname]: surinameConfigs,
  [Tenant.Trinidad]: trinidadConfigs,
  [Tenant.Cayman]: caymanConfigs,
};

export const getExtraBasicInfoQuestions = (
  tenant: Tenant,
  user: User,
): ExtraBasicInfoQuestions => {
  switch (tenant) {
    case Tenant.BVI:
      return bviGetExtraBasicInfoQuestions(user);
    case Tenant.Barbados:
      return barbadosGetExtraBasicInfoQuestions(user);
    case Tenant.Grenada:
      return grenadaGetExtraBasicInfoQuestions(user);
    case Tenant.Anguilla:
      return anguillaGetExtraBasicInfoQuestions(user);
    case Tenant.Dominica:
      return dominicaGetExtraBasicInfoQuestions(user);
    case Tenant.SaintKittsNevis:
      return saintKittsNevisGetExtraBasicInfoQuestions(user);
    case Tenant.SaintLucia:
      return saintLuciaGetExtraBasicInfoQuestions(user);
    case Tenant.SaintVincent:
      return saintVincentGetExtraBasicInfoQuestions(user);
    case Tenant.SintMaarten:
      return sintMaartenGetExtraBasicInfoQuestions(user);
    case Tenant.Guyana:
      return guyanaGetExtraBasicInfoQuestions(user);
    case Tenant.Suriname:
      return surinameGetExtraBasicInfoQuestions(user);
    case Tenant.Trinidad:
      return trinidadGetExtraBasicInfoQuestions(user);
    case Tenant.Cayman:
      return caymanGetExtraBasicInfoQuestions(user);
    default:
      return {};
  }
};

export const getTenantConfigs = (tenant?: Tenant) => {
  if (!tenant) return defaultConfigs;
  return appConfigs[tenant.toLowerCase() as Tenant];
};
